<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Students Achievement</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Students Achievement</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-4">
        <div class="faculty-div bg-white shadow">
          <div class="faculty-img">
            <img src="{{baseUrl}}/achievement/somesh-gondal.avif" class="img-fluid rounded-0 w-100 mt-4"
              alt="Somesh Vilasappa Gondal | GHRCACS, PUNE">
          </div>
          <!-- <div class="faculty-details text-center my-2 pt-3">
                    <h4>Somesh Vilasappa Gondal</h4>
                    <h6>BBA CA student</h6>
                    <h6>Placed at SET Education Technology Pvt. Ltd</h6>
                    <br>
                  </div> -->
        </div>
      </div>
      <div class="col-md-4">
        <div class="faculty-div bg-white shadow">
          <div class="faculty-img">
            <img src="{{baseUrl}}/achievement/prem-surve-nd-siddhesh-mirje.avif" class="img-fluid rounded-0 w-100 mt-4"
              alt="Prem Surve And Siddhesh Mirje | GHRCACS, PUNE">
          </div>
          <!-- <div class="faculty-details text-center my-2 pt-3">
                  <h4>Prem Surve And Siddhesh Mirje</h4>
                  <h6>BSc CS students</h6>
                  <h6> XDBS (ONDIRECT) as
                    Data Research Analysts</h6>
                  <br>
                </div> -->
        </div>
      </div>

    </div>
  </div>
</section>
